// src/services/policies.js (recommendations)
import api from './api';

/**
 * Service for managing security policies
 */
const policiesService = {
  /**
   * Get all security policies with optional filters
   * @param {Object} filters - Filter parameters (policy_type, is_enabled, skip, limit)
   * @returns {Promise<Array>} - List of policies
   */
  getPolicies: async (filters = {}) => {
  try {
    // Clean out empty string values to prevent 422 errors
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== '')
    );

    const response = await api.get('/policies/', { params: cleanedFilters });
    return response.data;
  } catch (error) {
    console.error('Error fetching policies:', error);
    throw error;
    }
  },

  /**
   * Get a single policy by ID
   * @param {string} policyId - Policy ID
   * @returns {Promise<Object>} - Policy details
   */
  getPolicy: async (policyId) => {
    try {
      const response = await api.get(`/policies/${policyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching policy ${policyId}:`, error);
      throw error;
    }
  },

  /**
   * Create a new security policy
   * @param {Object} policyData - Policy data
   * @returns {Promise<Object>} - Created policy
   */
  createPolicy: async (policyData) => {
    try {
      const response = await api.post('/policies/', policyData);
      return response.data;
    } catch (error) {
      console.error('Error creating policy:', error);
      throw error;
    }
  },

  /**
   * Update an existing policy
   * @param {string} policyId - Policy ID
   * @param {Object} policyData - Updated policy data
   * @returns {Promise<Object>} - Updated policy
   */
  updatePolicy: async (policyId, policyData) => {
    try {
      const response = await api.put(`/policies/${policyId}`, policyData);
      return response.data;
    } catch (error) {
      console.error(`Error updating policy ${policyId}:`, error);
      throw error;
    }
  },

  /**
   * Delete a policy
   * @param {string} policyId - Policy ID
   * @returns {Promise<void>}
   */
  deletePolicy: async (policyId) => {
    try {
      await api.delete(`/policies/${policyId}`);
    } catch (error) {
      console.error(`Error deleting policy ${policyId}:`, error);
      throw error;
    }
  }
};

export { policiesService };
export default policiesService;
